import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-colorpicker-config',
  templateUrl: './d-colorpicker-config.component.html',
  styles: []
})
export class DColorpickerConfigComponent extends DynamicComponentBase {
  static KEY = 'd-colorpicker-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}
}
